/*
    作業者の所属を選択するリスト
*/
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { PlantTeamMember } from "../../redux/memberSlice";
export type ProcCodeSelectProp = {
  // ラベル
  label: string;
  // 工場コード
  plantCode: string;
  // 加工コード==所属コード（チーム）
  selectProcCode: string;
  // 作業者が選択された場合のイベント処理
  handleMemberChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const TeamSelect: React.FC<ProcCodeSelectProp> = ({
  label,
  selectProcCode,
  plantCode,
  handleMemberChange,
}) => {
  // このコンポーネントでユニークなID
  const id =
    "proc-code-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  const plantTeamMember: PlantTeamMember[] = useSelector(
    (state: RootState) => state.member.plant_team_member
  );
  const teams = plantTeamMember.find((d) => d.plant_code === plantCode)?.teams;
  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <select
        id={id}
        onChange={handleMemberChange}
        value={selectProcCode}
        className="input-110"
      >
        <option value="">-</option>
        {teams?.map(({ proc_code, proc_name }) => (
          <option key={proc_code} value={proc_code}>{`${proc_name}`}</option>
        ))}
      </select>
    </>
  );
};
